"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useXScale = void 0;
const react_1 = require("react");
const scale_1 = require("../1d/utilities/scale");
const ChartContext_1 = require("../context/ChartContext");
function useXScale() {
    const { width, margin, xDomains, xDomain, mode } = (0, ChartContext_1.useChartData)();
    return (0, react_1.useMemo)(() => (0, scale_1.getXScale)({ width, margin, xDomains, xDomain, mode }), [margin, mode, width, xDomain, xDomains]);
}
exports.useXScale = useXScale;
